import React from 'react';

import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import { FaChevronLeft, FaTimes } from 'react-icons/fa';
import styled from 'styled-components';

import { mobile, Button } from '~/techstyle-shared/react-components';

const MobileTitleContainer = styled.div`
  width: 100%;
  padding: ${({ theme: { spacing } }) => spacing.sizes.pixels.m}px;
  background: ${({ theme: { colors } }) => colors.palette.white};
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 1px 0px 16px -3px rgba(0, 0, 0, 0.15);
`;

const Back = styled(Button).attrs({
  variant: 'unstyled',
})`
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 600;
`;
const BackIcon = styled(FaChevronLeft).attrs({
  size: 24,
})`
  margin-right: ${({ theme }) => theme.spacing.sizes.pixels.xs}px;
`;
const CloseIcon = styled(FaTimes).attrs({
  size: 24,
})``;

const Title = styled.div`
  display: flex;
  justify-content: center;
  font-size: 24px;
  ${mobile &&
  `
    font-size: 20px;
  `}
  font-weight: bold;
`;

export default function MobileStepTitleContainer({
  backFunction,
  children,
  exitFunction,
  exitRoute,
}) {
  const router = useRouter();
  const exitFunctionOrFallback = exitFunction || (() => router.push(exitRoute));
  return (
    <MobileTitleContainer>
      <Back onClick={backFunction}>
        <BackIcon />
      </Back>
      <Title>{children}</Title>
      <CloseIcon onClick={exitFunctionOrFallback} />
    </MobileTitleContainer>
  );
}

MobileStepTitleContainer.propTypes = {
  backFunction: PropTypes.func.isRequired,
  children: PropTypes.node,
  exitFunction: PropTypes.func,
  exitRoute: PropTypes.string,
};
